"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTypingAnnounce", {
    enumerable: true,
    get: function() {
        return _useTypingAnnounce.useTypingAnnounce;
    }
});
const _useTypingAnnounce = require("./useTypingAnnounce");
